<h3 class="mb-4 text-lg tracking-wider text-primary-500 md:text-xl">
  {{ ("impactReport.equivalent.title" | transloco).toLocaleUpperCase() }}
</h3>
<div class="mb-2 rounded-md border-2 border-solid border-primary-200">
  <div
    class="flex flex-col justify-start border-b-2 border-primary-200 bg-primary-100 p-4"
  >
    <h1 class="text-xl font-semibold">
      {{ kgTotal }}
    </h1>
    <p>kg CO2e</p>
  </div>
  <div class="grid grid-cols-1">
    @for (category of compareCar; track category) {
      <div
        class="flex flex-row items-center gap-4 border-b-2 border-primary-200 p-4"
      >
        <i-lucide name="{{ category.icon }}" [size]="36"></i-lucide>
        <div>
          <h1 class="text-xl font-semibold">{{ category.ecv }}</h1>
          <p>{{ `impactReport.equivalent.${category.name}` | transloco }}</p>
        </div>
      </div>
    }
  </div>
</div>
